import type { PaperProps } from '@mui/material'
import { mergeSx } from 'lib/helpers/mergeSx/mergeSx'
import * as tkn from '../../Modal.tokens'
import { MODAL_SIZES } from '../../Modal.styled'
import type { ModalSize, ModalPlacement } from '../../Modal.types'

interface UsePaperSlotPropsParams {
  size?: ModalSize
  fullScreen?: boolean
  placement?: ModalPlacement
  slotProps?: PaperProps
}

export const usePaperSlotProps = ({ size, fullScreen, placement, slotProps }: UsePaperSlotPropsParams): PaperProps => ({
  ...slotProps,
  sx: mergeSx(
    {
      '&&': {
        ...(!fullScreen && {
          width: size && MODAL_SIZES[size],
          maxWidth: size && MODAL_SIZES[size],
        }),
        ...(fullScreen && {
          margin: '8px',
          maxHeight: 'calc(100% - 16px)',
        }),
        background: tkn.ModalColorSurface,
        borderRadius: tkn.ModalBorderRadiusContainer,
        ...(placement === 'top' && {
          alignSelf: 'flex-start',
        }),
      },
      '@media (max-height:700px)': {
        marginTop: '8px',
        marginBottom: '8px',
        maxHeight: 'calc(100% - 16px)',
      },
    },
    slotProps?.sx,
  ),
})
